import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import SearchPaging from "./../factories/search-paging";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import "./../bindings/bao-number-box";
function SalesGroupViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.Name())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
}
Bao.inherit(SalesGroupViewModel, SearchPaging);
SalesGroupViewModel.prototype.PrimaryKey = "SalesGroupId";
SalesGroupViewModel.prototype.RefreshUrl = "SalesGroup/Get";
SalesGroupViewModel.prototype.SaveUrl = "SalesGroup/Save";
SalesGroupViewModel.prototype.DeleteUrl = "SalesGroup/Delete";
SalesGroupViewModel.prototype.IsInUseUrl = "SalesGroup/IsInUse";
SalesGroupViewModel.prototype.PermissionForward = "SalesGroupMoveForwardSearch";
SalesGroupViewModel.prototype.PermissionBackward = "SalesGroupMoveBackwardSearch";
SalesGroupViewModel.prototype.PermissionSave = "SalesGroupSave";
SalesGroupViewModel.prototype.PermissionRefresh = "SalesGroupRefresh";
SalesGroupViewModel.prototype.PermissionDelete = "SalesGroupDelete";
export default SalesGroupViewModel;